<div class="media">
  <div class="media-item" (click)="navigation.facebook()">
    <img class="social_icon" src="assets/iconmonstr-facebook-4.svg">
    Facebook
  </div>

  <div class="media-item" (click)="navigation.instagram()">
    <img class="social_icon" src="assets/iconmonstr-instagram-11.svg">
    Instagram
  </div>

  <div class="media-item" (click)="navigation.youtube()">
    <img class="social_icon" src="assets/iconmonstr-youtube-6.svg">
    YOUTUBE
  </div>

  <div class="media-item">
  <span (click)="navigation.home()" style="cursor: pointer;">
        <mat-icon class="back-icon">arrow_back_ios</mat-icon>
        ZURÜCK
      </span>
  </div>
</div>



